import React from 'react';
import { ClockCircleOutlined } from '@ant-design/icons';
import './ReportTimeline.css';
import { useTranslation } from 'react-i18next';

export function ReportTimeline(props) {
  const reportState = props.name;
  const isMobile = props.isMobile || false;
  const { t } = useTranslation('report');

  let list = ['Submitted', 'Under Review', ' '];

  if (reportState === 'Verified Scam') {
    list = [
      'Submitted',
      'Under Review',
      'Verified Scam',
      'Notify Brand',
      'Disruption In Progress',
      'Scam Disrupted',
    ];
  } else if (reportState === 'Verified Genuine') {
    list = ['Submitted', 'Under Review', 'Verified Genuine'];
  } else if (reportState === 'Notify Brand') {
    list = [
      'Submitted',
      'Under Review',
      'Verified Scam',
      'Notify Brand',
      'Disruption In Progress',
      'Scam Disrupted',
    ];
  } else if (reportState === 'Disruption In Progress') {
    list = [
      'Submitted',
      'Under Review',
      'Verified Scam',
      'Notify Brand',
      'Disruption In Progress',
      'Scam Disrupted',
    ];
  } else if (reportState === 'Scam Disrupted') {
    list = [
      'Submitted',
      'Under Review',
      'Verified Scam',
      'Notify Brand',
      'Disruption In Progress',
      'Scam Disrupted',
    ];
  }

  const getText = item => {
    switch (item) {
      case 'Submitted':
        return t('status.submitted');
      case 'Verified':
        return t('status.verified');
      case 'Verified Scam':
        return t('status.scam');
      case 'Verified Genuine':
        return t('status.genuine');
      case 'Under Review':
        return t('status.underReview');
      case 'Notify Brand':
        return t('status.brand');
      case 'Disruption In Progress':
        return t('status.disruptionInProgress');
      case 'Scam Disrupted':
        return t('status.disrupted');
      default:
        return '';
    }
  };

  return (
    <div className={`timeline-container ${isMobile ? 'timeline-container-mobile' : ''}`}>
      {list.map((item, index) => {
        const isCurrent = item === reportState;
        const isCompleted = list.indexOf(reportState) > index;

        const statusClass = isCurrent
          ? 'timeline-item current'
          : isCompleted
            ? 'timeline-item completed'
            : 'timeline-item';

        return (
          <div key={index} className={`${statusClass} ${isMobile ? 'timeline-item-mobile' : ''}`}>
            <div className={`timeline-icon ${isMobile ? 'timeline-icon-mobile' : ''}`}>
              {isCurrent ? <ClockCircleOutlined /> : <span className="dot" />}
            </div>
            <div className={`timeline-content ${isMobile ? 'timeline-content-mobile' : ''}`}>
              {getText(item)}
            </div>
          </div>
        );
      })}
    </div>
  );
}
